import React from 'react';
import clsx from 'clsx';
import {useIntl} from 'react-intl';
import {KTIcon} from '@/_metronic/helpers'
import {KpiValue} from '../../core/_models';

interface Props {
  trx: KpiValue;
  order: KpiValue;
  balance: number;
}

export const EarningsKpi: React.FC<Props> = ({trx, order, balance}) => {
  const intl = useIntl();
  const moneyFormat = (value: number) =>
    intl.formatNumber(value, { style: 'currency', currency: 'EUR' });
  const curr = trx.curr + order.curr;
  const prev = trx.prev + order.prev;
  const evolution = prev !== 0 ? ((curr - prev) / prev) * 100 : 0;
  const evolutionFormatted = evolution.toFixed(2);

  return (
    <div className={`card card-flush`}>
      <div className='card-header pt-5'>
        <div className='card-title d-flex flex-column'>
         <div className='d-flex align-items-center'>
           <span className='fs-2hx fw-bold text-gray-900 me-2 lh-1 ls-n2'>
             {moneyFormat(curr)}
           </span>

           <span className={clsx('badge fs-base', {
             'badge-light-success' : evolution > 0,
               'badge-light-danger' : evolution <= 0,
           })}>
             <KTIcon
               iconName={`arrow-${evolution > 0 ? 'up' : 'down'}`}
               className={clsx('fs-5 ms-n1', {
                 'text-success': evolution > 0,
                 'text-danger': evolution <= 0,
               })}
             />
              {evolutionFormatted}%
           </span>
         </div>
         <span className='text-gray-500 pt-1 fw-semibold fs-6'>
           Total earnings
         </span>
       </div>
      </div>

      <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>

       <div className='d-flex flex-column content-justify-center flex-row-fluid'>
         <div className='d-flex fw-semibold align-items-center'>
           <div className='bullet w-8px h-3px rounded-2 bg-success me-3'></div>
           <div className='text-gray-500 flex-grow-1 me-4'>Transaction</div>
           <div className='fw-bolder text-gray-700 text-xxl-end'>
             {moneyFormat(trx.curr)}
           </div>
         </div>

         <div className='d-flex fw-semibold align-items-center my-3'>
           <div className='bullet w-8px h-3px rounded-2 bg-primary me-3'></div>
           <div className='text-gray-500 flex-grow-1 me-4'>Orders</div>
           <div className='fw-bolder text-gray-700 text-xxl-end'>
             {moneyFormat(order.curr)}
           </div>
         </div>

         <div className='d-flex fw-semibold align-items-center'>
           <div className='bullet w-8px h-3px rounded-2 bg-danger me-3'></div>
           <div className='text-gray-500 flex-grow-1 me-4 fst-italic'>
              Deferred Revenue (Unspent Credits)
            </div>
           <div className='fw-bolder text-gray-700 text-xxl-end'>
             {moneyFormat(balance)}
           </div>
         </div>
       </div>
      </div>
    </div>
  );
}

export const EarningsKpiSkeleton = () => (
  <div className="card card-flush">
  <div className="card-header pt-5">
    <div className="card-title d-flex flex-column">
      <div className="d-flex align-items-center">
        <span className="placeholder-glow">
          <span className="placeholder" style={{ width: '120px', height: '32px' }}></span>
        </span>

        <span className="badge fs-base badge-light-secondary d-flex align-items-center ms-2">
          <span className="placeholder rounded-circle me-1" style={{ width: 14, height: 14 }}></span>
          <span className="placeholder" style={{ width: '40px', height: '16px' }}></span>
        </span>
      </div>

      <span className="text-gray-500 pt-1 fw-semibold fs-6">
        Total earnings
      </span>
    </div>
  </div>

  <div className="card-body pt-2 pb-4 d-flex flex-wrap align-items-center">
    <div className="d-flex flex-column content-justify-center flex-row-fluid">

      <div className="d-flex fw-semibold align-items-center">
        <div className="bullet w-8px h-3px rounded-2 bg-success me-3"></div>
        <div className="text-gray-500 flex-grow-1 me-4">Transaction</div>
        <div className="fw-bolder text-gray-700 text-xxl-end placeholder-glow">
          <span className="placeholder" style={{ width: '80px', height: '20px' }}></span>
        </div>
      </div>

      <div className="d-flex fw-semibold align-items-center my-3">
        <div className="bullet w-8px h-3px rounded-2 bg-primary me-3"></div>
        <div className="text-gray-500 flex-grow-1 me-4">Orders</div>
        <div className="fw-bolder text-gray-700 text-xxl-end placeholder-glow">
          <span className="placeholder" style={{ width: '80px', height: '20px' }}></span>
        </div>
      </div>

      <div className="d-flex fw-semibold align-items-center">
        <div className="bullet w-8px h-3px rounded-2 bg-danger me-3"></div>
        <div className="text-gray-500 flex-grow-1 me-4 fst-italic">
          Deferred Revenue (Unspent Credits)
        </div>
        <div className="fw-bolder text-gray-700 text-xxl-end placeholder-glow">
          <span className="placeholder" style={{ width: '80px', height: '20px' }}></span>
        </div>
      </div>

    </div>
  </div>
</div>

)
